import script from "./CardInfoExperiencia.vue?vue&type=script&setup=true&lang=js"
export * from "./CardInfoExperiencia.vue?vue&type=script&setup=true&lang=js"

import "./CardInfoExperiencia.vue?vue&type=style&index=0&id=4342e3b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4342e3b6"]])

export default __exports__